import { createFileRoute } from "@tanstack/react-router";
import FederalEmployeeHub from "@/pages/FederalEmployeeHub";
export const Route = createFileRoute("/federal-employee-mental-health")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Federal Employee Mental Health | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Mental health treatment for federal employees: TMS, SAINT TMS, SPRAVATO, and therapy. Learn about FEHB coverage in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "Federal Employee Mental Health | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Mental health treatment for federal employees: TMS, SAINT TMS, SPRAVATO, and therapy. Learn about FEHB coverage in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/federal-employee-mental-health",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/federal-employee-mental-health",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <FederalEmployeeHub />;
}
